import { render, staticRenderFns } from "./ThirdSettingsComp.vue?vue&type=template&id=7aec4967&scoped=true&"
import script from "./ThirdSettingsComp.vue?vue&type=script&lang=js&"
export * from "./ThirdSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./ThirdSettingsComp.vue?vue&type=style&index=0&id=7aec4967&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aec4967",
  null
  
)

export default component.exports